export default "__VITE_ASSET__7bbde676__"